module.exports = __webpack_public_path__ + "media/images/flags/32/Gambia-c42c2fbb4bd0a027bf6e0b7f21535646.png";